import { Injectable } from '@angular/core';
import { SessionService } from './session.service';
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { tap, catchError, take } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';

@Injectable({ providedIn: 'root' })
export class AuthFacade {
	constructor(
		private sessionService: SessionService,
		private router: Router,
		private toastr: ToastrService,
		private translate: TranslateService
	) {}

	loginAndRedirect(
		username: string,
		password: string,
		returnUrl?: string,
		entityType?: string,
		entityId?: string
	): Observable<any> {
		return this.sessionService.login(username, password).pipe(
			tap(() => {
				const target = returnUrl ? returnUrl : '/admin/dashboard';
				void this.router.navigateByUrl(target);
			}),
			catchError(err => {
				const key = err?.code === 'NotAuthorizedException' ? 'login.incorrectUserPassword' : 'login.loginError';
				this.translate
					.get(key)
					.pipe(take(1))
					.subscribe((message: any) =>
						this.toastr.error('', message as string, {
							closeButton: true,
							progressBar: true,
							positionClass: 'toast-bottom-center',
							extendedTimeOut: 5000,
							timeOut: 10000
						})
					);
				return throwError(err);
			})
		);
	}

	logoutAndRedirect(): Observable<void> {
		return this.sessionService.logout().pipe(
			tap(() => {
				void this.router.navigate(['/login']);
			})
		);
	}
}
